<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
      <vs-list>
        <vs-list-header title="구(Clause)를 조합하여 문장을 완성합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="ww-jumbotron-content-sentence lg:p-6 p-4 mb-6 rounded-lg text-center text-primary font-bold mb-3">
        {{ content.translation }}
      </div>   

      <div class="ww-jumbotron-content-sentence lg:p-6 p-4 mb-6 rounded-lg text-center">
         <vs-alert color="primary" active="true" class="mb-3">
            아래에 끌어다 놓으세요.
        </vs-alert>
        <div class="vx-row">
          <div class="vx-col w-full">
              <draggable style="min-height: 80px" v-if="!hint" :list="dropList" group="words" class="cursor-move" @change="checkDrop">
                  <vs-chip class="chip-font" color="primary" v-for="(listItem, index) in dropList" :key="index">{{ listItem.value }}</vs-chip>
              </draggable>
              <div style="height: 80px" v-if="hint" class="text-center text-primary font-bold items-center p-4">
                {{ content.sentence }}
              </div>  
          </div>
        </div>
        
        <vs-divider class="m-1" />

        <div class="vx-row mt-12">
          <!-- <div class="ww-jumbotron-content-translation lg:p-6 p-4 rounded-lg text-center"> -->
            <div class="vx-col w-full flex items-center justify-center">
                <draggable style="min-height: 80px" :list="dragList" group="words" class="cursor-move">
                  <vs-chip class="chip-font" color="success" v-for="(listItem, index) in dragList" :key="index">{{ listItem.trans }}</vs-chip>
                </draggable>
            </div>
          <!-- </div> -->
        </div>  
      </div>  

      <div class="text-center" >
        <audio ref="audioPlayer" 
            v-on:ended="audioFinish" 
            hidden
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>

    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import draggable from 'vuedraggable'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    draggable
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      hint: false,
      dragList: [],
      dropList: []
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    }
  },
  methods: {
    onReload () {
      this.contentIndex = 0
      this.dragList = []
      this.dropList = []
      this.hint = false
      this.startAlert()
    },
    onStart () {
      this.dragList = this.getMixedDragList()
    },
    getMixedDragList () {
      const example = this.content.example.slice()
      const dragList = []
      for (let i = 0; i < example.length; i++) {
        dragList.push({value: example[i], trans: example[i].toLowerCase()})
      }

      let j = 0, x = 0, i = 0
      for (i = dragList.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1))
        x = dragList[i]
        dragList[i] = dragList[j]
        dragList[j] = x
      }
      return dragList
    },
    startAlert () {
      this.startStudyDlg('구(Clause)를 조합하여 문장을 완성합니다.')
    },
    audioFinish () {

      if (this.contentIndex >= this.contentsLen - 1) {
        this.onComplete()
      } else {
        this.dropList = []
        this.hint = false
        this.contentIndex++
        this.dragList = this.getMixedDragList()
      }
    },
    acceptAlert () {
      this.onStart()
    },
    checkDrop () {

      let correct = true
      if (this.dropList.length === this.content.example.length) {
        for (let i = 0; i < this.content.example.length; i++) {
          if (this.dropList[i].value !== this.content.example[i]) {
            correct = false
            break 
          }
        }
        if (correct) {

          this.correct()

          setTimeout(function () {
            this.hint = true
            this.audioPlayer.src = this.content.audio
            this.audioPlayer.play()
          }.bind(this), 1500)

        } else {

          this.inCorrect()

          this.dropList = []
          this.hint = false
          this.dragList = this.getMixedDragList()
        }
      }
    },
    onHint () {
      this.hint = true
      setTimeout(function () {
        this.hint = false
      }.bind(this), 2000)
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)

    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        example: contentJson.example[i].split('|'),
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }

    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content-sentence {
    border:1px solid #7367F0;
}
.ww-jumbotron-content-translation {
    border:1px solid #28C76F;
}
.chip-font {
  font-size: 18px
}
</style>